import React, { createContext, useContext, useState } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { fetchRefreshToken } from '../../components/api/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [continuee, setContinuee] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserCookie, setCurrentUserCookie] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pathName, setPathName] = useState(window.location.pathname);

  const [RefreshCaptcha, setRefreshCaptcha] = useState(false);
  const [RegisterCaptcha, setRegisterCaptcha] = useState('');

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [CookieToken, setCookieToken] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = Cookies.get('token');
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });
  // console.log(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000));

  const [tokenLogin, setTokenLogin] = useState(() => {
    if (typeof window !== 'undefined') {
      // خواندن مقدار اولیه از لوکال استوریج
      const storedValueToken = localStorage.getItem('tokenLogin');
      const accessTokenNew = JSON.parse(storedValueToken);
      // console.log("accessTokenNew", accessTokenNew);
      // console.log("accessTokenNew.accessToken--->", accessTokenNew.accessToken);
      // console.log("storedValueToken", JSON.parse(storedValueToken));
      // اگر مقدار در لوکال استوریج وجود داشته باشد، از آن استفاده کنید. در غیر اینصورت، از مقدار پیشفرض استفاده کنید.
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });

  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      // console.log("decoded", decoded);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };

  const checkEdame = async () => {
    if (isTokenExpired(tokenLogin?.accessTokenExpiration)) {
      if (isTokenExpired(tokenLogin?.refreshTokenExpiration)) {
        setContinuee(true);

        // localStorage.setItem("edame", JSON.stringify(edame));
        localStorage.clear();
      } else {
        // console.log("edame with refreshToken");

        await fetchRefreshToken(tokenLogin?.refreshToken, tokenLogin?.email);
      }
    } else {
      try {
        // console.log("check edame true ");
        // localStorage.setItem("edame", JSON.stringify(edame));
      } catch (error) {
        console.log('errorFetchAllData222222222222', error);
      }
    }
  };

  const Logout = () => {
    localStorage.clear();
    document.cookie =
      'token=; Path=/;domain=.ilaws.net; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    Cookies.remove('token');
    // Cookies.remove('token', {
    //   domain: window.location.hostname.includes('localhost')
    //     ? '.localhost'
    //     : '.ilaws.net',
    //   path: '/',
    // });
    setCurrentUser(null);
    setLoading(false);
    window.location.assign(`${pathName === '/login' ? '/' : pathName}`);
  };
  const GetLocalEdame = () => {
    if (process.env.REACT_APP_EDAME == 'false') {
      // console.log("tokenLogin.accessToken=========>", tokenLogin.accessToken);
      if (
        typeof window !== 'undefined' &&
        isTokenExpired(tokenLogin?.accessToken)
      ) {
        // console.log("trueeeeeeeeeeeee1111111111111111111111");
        let edame = localStorage.getItem('edame');
        // console.log("edame12345", edame);
        if (edame) {
          return JSON.parse(localStorage.getItem('edame'));
        } else {
          return false;
        }
        // return true;
      } else {
        // console.log("trueeeeeeeeeeeee222222222222222222222222");
        let edame = localStorage.getItem('edame');
        // console.log("edame98765", edame);
        // console.log(
        //   "tokenLogin.accessToken-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=->>>>>>>",
        //   tokenLogin.accessToken,
        // );
        if (edame) {
          // console.log("test,test,test,test,test,test,test,test,");
          return JSON.parse(localStorage.getItem('edame'));
        } else {
          // console.log(
          //   "test false,test false,test false,test false,test false,",
          // );
          return false;
        }
        localStorage.clear();
        // return false;
      }
    } else {
      // console.log("first", process.env.REACT_APP_EDAME);
      // console.log("trueeeeeeeeeeeee");
      return true;
    }
  };

  const getLocalStorager = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      let list = localStorage.getItem('list');
      if (list && list !== `undefined`) {
        return JSON.parse(localStorage.getItem('list'));
      } else {
        return [];
      }
    }
  };

  return (
    <AuthContext.Provider
      value={{
        continuee,
        setContinuee,
        currentUser,
        setCurrentUser,
        currentUserCookie,
        setCurrentUserCookie,
        email,
        setEmail,
        password,
        setPassword,
        Logout,
        CookieToken,
        setCookieToken,
        checkEdame,
        GetLocalEdame,
        getLocalStorager,
        tokenLogin,
        setTokenLogin,
        pathName,
        setPathName,
        RefreshCaptcha,
        setRefreshCaptcha,
        RegisterCaptcha,
        setRegisterCaptcha,
        isTokenExpired,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
